import {useGetAlphaCatalogueQuery} from '@dms/api/core';
import {browserStorageKey} from '@dms/config';

import {Nullish} from 'shared/web';

import {useVehicleCatalogueLogic, VehicleCatalogueReturnType} from 'features/vehicle-catalogue';

export function useVehicleCatalogue(
  type: string | Nullish,
  shouldSortByLabel = true
): VehicleCatalogueReturnType {
  const {data, isError, isLoading} = useGetAlphaCatalogueQuery({
    lang: String(localStorage.getItem(browserStorageKey.LAST_KNOWN_LANGUAGE)),
  });

  return useVehicleCatalogueLogic({data, isError, isLoading, type, shouldSortByLabel});
}
